export function truncate( str: string | undefined, length: number = 30 ): string {
  if ( !str ) return 'N/A';
  return str.length > length ? str.substring( 0, length ) + '...' : str;
}

// Prefix a noun with a count, appending "s" for anything other than 1
export function pluralize( noun: string, n: number ): string {
  if ( n === 1 ) return `1 ${ noun }`;
  return `${ n } ${ noun }s`;
}

